import { render, staticRenderFns } from "./test-input.vue?vue&type=template&id=b4f9085c&scoped=true&"
import script from "./test-input.vue?vue&type=script&lang=js&"
export * from "./test-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4f9085c",
  null
  
)

export default component.exports